// extracted by mini-css-extract-plugin
export default {"main_conatiner":"components_main_conatiner__s1lqR","main_details":"components_main_details__qhjqy","data_conatiner":"components_data_conatiner__UTVDq","imp":"components_imp__UCEDQ"};